import { getConfig } from '@/lib/config'
import type { UpsertUserPreferencesOutput } from '@/shared/api-generated-types'
import * as Sentry from '@sentry/nextjs'

const {
  publicRuntimeConfig: {
    graphqlApi: { url },
  },
} = getConfig()

export async function upsertUserPreferences(tagIds: string[]): Promise<boolean> {
  try {
    const mutationBody = {
      query: `
        mutation upsertUserPreferences($input: UpsertUserPreferencesInput!) {
          upsertUserPreferences(input: $input) {
            __typename success
          }
        }
      `,
      variables: {
        input: { tagIds },
      },
    }
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(mutationBody),
    })
    const parsedResponse = (await response.json()) as {
      data: { upsertUserPreferences: UpsertUserPreferencesOutput }
    }
    return parsedResponse.data.upsertUserPreferences.success
  } catch (err) {
    // Log this error to sentry but dont panic.
    Sentry.captureException(err)
    return false
  }
}
